import { fetchApiCall } from '../lib/functions';

//Actions
export const GET_USER_LOAD_FILE_STATUS = 'api/GET_USER_LOAD_FILE_STATUS';

const GET_API_ROOT_URL = process.env.REACT_APP_FILE_UPLOAD_GET_STATUS_API_URL;

export const getLoadFileStatus = (request = {}) => {
    return async (dispatch, getState) => {
        const { pathParam } = request;
        delete request.search;
        return fetchApiCall({
            endPoint : GET_API_ROOT_URL.replace('{email}',pathParam),
            method   : 'GET',
            auth     : getState().gCache.data.auth,
            type     : GET_USER_LOAD_FILE_STATUS,
            request,
            dispatch
        });
    };
};

